// extracted by mini-css-extract-plugin
export default {"FormCardTitle":"FormCardTitle_FormCardTitle__29IbX"};